export var VerificationResult = /*#__PURE__*/function (VerificationResult) {
  VerificationResult["CHECK_FAILURE"] = "check_failure";
  VerificationResult["LOW_QUALITY"] = "low_quality";
  VerificationResult["NAME_NOT_MATCH"] = "name_not_match";
  VerificationResult["NOT_CHECKED"] = "not_checked";
  VerificationResult["SUCCESSFULLY_PASSED"] = "successfully_passed";
  VerificationResult["IELTS_SCORE_MISMMATCH"] = "ielts_score_mismatch";
  VerificationResult["STUDENT_INELIGIBLE"] = "student_ineligible";
  VerificationResult["DOCUMENT_MISMATCH"] = "document_mismatch";
  return VerificationResult;
}({});